// extracted by mini-css-extract-plugin
export default {"rankingDropdown":"_5gWk","name":"_34CG","degree":"_1iAw","time":"_1RVo"};